import axios from 'axios';
import qs from 'qs';
import router from '../router';

const debug = false;
const ApiUrl = debug ? ' http://jinxiaocun.new.pro3.liuniukeji.net/Front/' : 'http://www.ysmsy.com/Front/'; //接口总地址
// const ApiUrl = 'http://fangzhen.ysmsy.com/Front/';
axios.defaults.timeout = 30000;
// axios.defaults.baseURL = "/api";  //好像没啥用
// access-Control-Allow-Origin:*,
axios.defaults.headers.head['Access-Control-Allow-Origin'] = '*';
// ("Access-Control-Allow-Origin:*");
//http request 拦截器
// 请求超时时间
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;application/json;charset=UTF-8';
// Content-Type: application/json ： 请求体中的数据会以json字符串的形式发送到后端
// Content-Type: application/x-www-form-urlencoded：请求体中的数据会以普通表单形式（键值对）发送到后端
// Content-Type: multipart/form-data： 它会将请求体的数据处理为一条消息，以标签为单元，用分隔符分开。既可以上传键值对，也可以上传文件。
let lanjie = true;
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data) {
  data.user_type = 2;
  data.lang = 1;
  return new Promise((resolve, reject) => {
    axios.post(ApiUrl + url, qs.stringify(data)).then(
      (response) => {
        resolve(response.data);
        if (response.data.status == 1) {
          resolve(response.data);
        } else if (response.data.status == 401) {
          resolve(response.data);
          if (lanjie) {
            lanjie = false;
            // this.$store.commit('setStatus');
            // Message(response.data.info);
          }
          router.push({
            path: '/',
          });
          localStorage.clear();
        }
      },
      (err) => {
        reject(err);
      }
    );
  });
}
/**
 *
 * @param {String} url 接口链接
 * @param {file} file 上传的file
 * @returns 使用这个axios时用fromData打包数据
 */
export function uploadImg(url, data) {
  // console.log(data);
  return new Promise((resolve, reject) => {
    const http = axios.create();
    http({
      method: 'POST',
      url: ApiUrl + url,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
  // const http = axios.create({
  //     baseURL: ApiUrl
  // })
  // return http({
  //     method: "POST",
  //     url,
  //     data: file,
  //     headers: {
  //         'Content-Type': 'multipart/form-data'
  //     }
  // })
  // // eslint-disable-next-line quotes
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
